'use client';
import { useEffect } from 'react';
import Hotjar from '@hotjar/browser';

const HotjarAnalytics = () => {
  useEffect(() => {
    const siteId = 6391289;
    const hotjarVersion = 6;

    if (typeof window !== 'undefined') {
      Hotjar.init(siteId, hotjarVersion);
    }
  }, []);

  return null;
};

export default HotjarAnalytics;
